import React, { useEffect, useState } from 'react';

import CheckIcon from '@material-ui/icons/Check';
import { makeStyles } from '@material-ui/core';

import { XGrid } from '@material-ui/x-grid';
import { displayDateTime } from 'reducers/TimeReducer';
import TopCard from './TopCard';
import AttatchmentsActions from './AttatchmentsActions';

const useStyles = makeStyles(theme => ({
  gridWrap: {
    width: '100%',
    // boxSizing: 'border-box',
    height: '450px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    minHeight: theme.spacing(6),
    width: '100%',
  },
  filterWrap: {
    flexShrink: 1,
    flexBasis: 400,
  },
  filter: {
    width: '100%',
  },
  action: {
    flexGrow: 0,
    flexShrink: 0,
    width: 'auto',
    marginLeft: theme.spacing(1),
    textAlign: 'right',
  },
}));

const bool = params => (params.value ? <CheckIcon /> : <span></span>);

const columns = [
  { field: 'Code', headerName: 'Code', width: 150, hide: false },

  { field: 'Description', headerName: 'Description', width: 150, hide: false },
  { field: 'Category', headerName: 'Category', width: 150, hide: false },
  { field: 'IsDefault', headerName: 'Default', width: 150, renderCell: bool },
  { field: 'IsDeleted', headerName: 'Deleted', width: 150, renderCell: bool },
  { field: 'IsActive', headerName: 'Active', width: 150, renderCell: bool },
  { field: 'WaitTime', headerName: 'Wait Time', width: 150 },

  { field: 'Flags', headerName: 'Flags', width: 100 },
  { field: 'Code2', headerName: 'Code 2', width: 150 },
  { field: 'Description2', headerName: 'Description 2', width: 150 },
  { field: 'Code3', headerName: 'Code 3', width: 100 },
  { field: 'Description3', headerName: 'Description 3', width: 150 },
  { field: 'Code4', headerName: 'Code 4', width: 100 },
  { field: 'Description4', headerName: 'Description 4', width: 150 },
  {
    field: 'Created',
    headerName: 'Created',
    width: 120,
    valueFormatter: params => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'CreatedBy', headerName: 'Created By', width: 150, hide: false },
  {
    field: 'Updated',
    headerName: 'Updated',
    width: 120,
    valueFormatter: params => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150, hide: false },
  {
    field: 'IsDeleted',
    headerName: 'Is Deleted',
    width: 100,
    format: 'bool',
    renderCell: bool,
    hide: false,
  },
  {
    field: 'Deleted',
    headerName: 'Deleted',
    width: 120,
    valueFormatter: params => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'DeletedBy', headerName: 'Deleted By', width: 150, hide: false },
  { field: 'DeletedIP', headerName: 'Deleted IP', width: 140, hide: false },
];
const CadTypesTab = props => {
  const { cadTypes, ptsSOPID } = props;
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState(null);

  useEffect(() => {
    setRows(cadTypes);
  }, [cadTypes]);

  return (
    <div>
      <TopCard parent="CADType" ptsSOPID={ptsSOPID} />
      <h5>Event Types</h5>
      <AttatchmentsActions ParentType="CADType" ptsSOPID={ptsSOPID} selection={selection} />

      <div className={classes.gridWrap}>
        <XGrid
          columns={columns}
          rows={rows}
          rowHeight={38}
          disableMultipleSelection
          getRowId={row => row.IntCode}
          onSelectionModelChange={newSelection => {
            setSelection(parseInt(newSelection.selectionModel[0]));
          }}
        />
      </div>
    </div>
  );
};

export default CadTypesTab;
